import { DashboardFilters } from '../components/dashboard/GoalsDashboard/reducer';
import { Criteria } from '../models';

const filterKeys = {
  role: 'roles',
  region: 'regions',
  subRegion: 'subRegion',
  salesChannel: 'salesChannel',
  relationship: 'relationship',
};

// create array of {key, value} to send to query
export const buildFilterArray = (state: Partial<DashboardFilters>) => {
  let filters = Object.entries(filterKeys).map(([key, stateKey]) => ({
    key,
    value: state[stateKey],
  }));
  // filter out with empty values
  filters = filters?.filter((filter) => filter.value?.length > 0);
  // spread arrays
  return [].concat(...filters);
};

type TFormatData = {
  data: number[];
  labels: string[];
};

type TFormatDoughnutDataInput = {
  amount: number;
  criteria: Criteria;
}[];

export const formatDoughnutData = (
  items: TFormatDoughnutDataInput
): TFormatData => {
  // array labels and values
  const labels = items?.map(
    (item) => `${item.criteria.lowerRange}% - ${item.criteria.upperRange}%`
  );
  const data = items?.map((item) => item.amount);
  return {
    data,
    labels,
  };
};

type TFormatBarDataInput = {
  metric: JSON;
  key: string;
}[];

export const formatBarData = (items: TFormatBarDataInput): TFormatData => {
  // metrics key values
  let data = items?.reduce((acc, item) => {
    const values = Object.entries(item.metric).map(([_key, value]) => {
      if (_key === 'total') return value;
      return value;
    });
    return [...acc, ...values.map((value) => value)];
  }, []);

  // labels for each key
  const labels = items?.reduce((acc, item) => {
    const values = Object.entries(item.metric).map(
      ([key, _value]) => `${item.key} - ${key === 'total' ? 'Total' : key}`
    );
    return [...acc, ...values.map((value) => value)];
  }, []);

  data = Object.values(data ?? {}) ?? [];

  return {
    data,
    labels,
  };
};
